import { FlexPurgeCommandArgs, FlexPurgeQuery } from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import t from '../../i18n/I18n';
import { clearSelectedItem, onDeletedSuccessfully } from '../../util/AssetsUtil';
import _ from 'lodash';

export default class PurgeQuery {
  updateProgress = _.noop;

  constructor(updateProgress) {
    this.updateProgress = updateProgress;
  }

  run(assets, inFuids) {
    const query = new FlexPurgeQuery();
    let message: FlexPurgeCommandArgs = new FlexPurgeCommandArgs();
    message.setInfuids(inFuids);
    query.message = message;
    this.updateProgress(0, t('PLEASE_WAIT'), 'RUNNING');
    query
      .run()
      .then(
        (resp) => {
          this.updateProgress(100, resp.getSuccessMessage(), 'DONE');
          if (!resp.isSuccess()) ErrorHandler.handleError(resp.getSuccessMessage());
          else {
            onDeletedSuccessfully(assets, true);
            clearSelectedItem(inFuids);
          }
        },
        (failedResp) => {
          const error = failedResp.errorDetails ? failedResp.errorDetails : t('DEFAULT_ERROR_MSG');
          ErrorHandler.handleError(error);
          this.updateProgress(100, error, null, false);
        }
      )
      .finally(() => {
        if (this.updateProgress) {
          this.updateProgress(100, '', null, false);
        }
      });
  }
}
